import iComponents from "../../secrets-web/src/components/items";

import DocLink from "./DocLink";
import UserInfo from "./UserInfo";

const itemsComponents = {
  ...iComponents,
  DocLink,
  UserInfo
}

export default itemsComponents